"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const moment = require("moment");
const LandingStore_1 = require("./landing/LandingStore");
const DialogReducer_1 = require("./shared/Dialog/DialogReducer");
const TemplateConstants_1 = require("./shared/Template/TemplateConstants");
const Business_1 = require("./models/Business");
const Survey_1 = require("./models/Survey");
var ProgressState;
(function (ProgressState) {
    ProgressState[ProgressState["None"] = 0] = "None";
    ProgressState[ProgressState["Loading"] = 1] = "Loading";
    ProgressState[ProgressState["Success"] = 2] = "Success";
    ProgressState[ProgressState["Failed"] = 3] = "Failed";
})(ProgressState = exports.ProgressState || (exports.ProgressState = {}));
var UserType;
(function (UserType) {
    UserType[UserType["Administrator"] = 1] = "Administrator";
    UserType[UserType["User"] = 2] = "User";
    UserType[UserType["Moderator"] = 3] = "Moderator";
    UserType[UserType["OrganizationOwner"] = 4] = "OrganizationOwner";
})(UserType = exports.UserType || (exports.UserType = {}));
var OrganizationStatus;
(function (OrganizationStatus) {
    OrganizationStatus[OrganizationStatus["Pending"] = 0] = "Pending";
    OrganizationStatus[OrganizationStatus["Inactive"] = 1] = "Inactive";
    OrganizationStatus[OrganizationStatus["Active"] = 2] = "Active";
})(OrganizationStatus = exports.OrganizationStatus || (exports.OrganizationStatus = {}));
exports.SELECT_OPTIONS = {
    [Survey_1.SurveyQuestionTypeEnum.Text]: "Text Box",
    [Survey_1.SurveyQuestionTypeEnum.Checkbox]: "Check Box Selection",
    [Survey_1.SurveyQuestionTypeEnum.Button]: "Button Selection",
    [Survey_1.SurveyQuestionTypeEnum.DropDown]: "Drop-Down List Selection",
    [Survey_1.SurveyQuestionTypeEnum.Option]: "Option Box",
    [Survey_1.SurveyQuestionTypeEnum.TrueOrFalse]: "True or False",
    [Survey_1.SurveyQuestionTypeEnum.ScaleOf5]: "Scale of 5 Selection (1 to 5)",
    [Survey_1.SurveyQuestionTypeEnum.ScaleOf10]: "Scale of 10 Selection (1 to 10)"
};
exports.SELECT_OPTIONS_ARR = [{
    value: Survey_1.SurveyQuestionTypeEnum.Text,
    label: exports.SELECT_OPTIONS[Survey_1.SurveyQuestionTypeEnum.Text]
}, {
    value: Survey_1.SurveyQuestionTypeEnum.Checkbox,
    label: exports.SELECT_OPTIONS[Survey_1.SurveyQuestionTypeEnum.Checkbox]
}, {
    value: Survey_1.SurveyQuestionTypeEnum.Button,
    label: exports.SELECT_OPTIONS[Survey_1.SurveyQuestionTypeEnum.Button]
}, {
    value: Survey_1.SurveyQuestionTypeEnum.DropDown,
    label: exports.SELECT_OPTIONS[Survey_1.SurveyQuestionTypeEnum.DropDown]
}, {
    value: Survey_1.SurveyQuestionTypeEnum.Option,
    label: exports.SELECT_OPTIONS[Survey_1.SurveyQuestionTypeEnum.Option]
}, {
    value: Survey_1.SurveyQuestionTypeEnum.TrueOrFalse,
    label: exports.SELECT_OPTIONS[Survey_1.SurveyQuestionTypeEnum.TrueOrFalse]
}, {
    value: Survey_1.SurveyQuestionTypeEnum.ScaleOf5,
    label: exports.SELECT_OPTIONS[Survey_1.SurveyQuestionTypeEnum.ScaleOf5]
}, {
    value: Survey_1.SurveyQuestionTypeEnum.ScaleOf10,
    label: exports.SELECT_OPTIONS[Survey_1.SurveyQuestionTypeEnum.ScaleOf10]
}];
exports.CustomerEndDates = {
    All: "-1",
    OneWeek: "7",
    OneMonth: "30",
    ThreeMonth: "90",
    SixMonth: "180",
    NineMonth: "270",
    OneYear: "365",
    Custom: "0"
};
exports.URL_regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
exports.ROUTES = {
    Nowhere: "javascript:void(0);",
    Landing: {
        Main: "/",
        Terms: "/terms",
        Login: (orgRoutePrefix = ':orgRoutePrefix') => `/${orgRoutePrefix}/login`,
        Register: (orgRoutePrefix = ':orgRoutePrefix') => `/${orgRoutePrefix}/register`,
        ForgotPassword: (orgRoutePrefix = ':orgRoutePrefix') => `/${orgRoutePrefix}/forgot-password`,
        AcceptOrganization: (token = ':token') => `/organization/accept/${token}`,
        DeclineOrganization: (token = ':token') => `/organization/decline/${token}`,
        AcceptOrganizationUser: (token = ':token') => `/organization/user/accept/${token}`,
        SetupOrganization: (token = ':token') => `/setup/${token}`,
        SetupOrganizationUser: (token = ':token') => `/setup/user/${token}`
    },
    Administration: {
        Main: (orgRoutePrefix = ':orgRoutePrefix') => `/${orgRoutePrefix}/app/admin`,
        Businesses: (orgRoutePrefix = ':orgRoutePrefix') => `/${orgRoutePrefix}/app/admin/businesses`,
        BusinessesAdd: (orgRoutePrefix = ':orgRoutePrefix') => `/${orgRoutePrefix}/app/admin/businesses/add`,
        Users: (orgRoutePrefix = ':orgRoutePrefix') => `/${orgRoutePrefix}/app/admin/users`,
        AddUser: (orgRoutePrefix = ':orgRoutePrefix') => `/${orgRoutePrefix}/app/admin/users/add`,
        EditUser: (orgRoutePrefix = ':orgRoutePrefix', userId = ':id') => `/${orgRoutePrefix}/app/admin/edit/user/${userId}`,
        EditAmbassador: (orgRoutePrefix = ':orgRoutePrefix', userId = ':id') => `/${orgRoutePrefix}/app/admin/edit/ambassador/${userId}`,
        GeneralBlackWords: (orgRoutePrefix = ':orgRoutePrefix') => `/${orgRoutePrefix}/app/admin/general/blackWords`,
        OrgConfiguration: (orgRoutePrefix = ':orgRoutePrefix') => `/${orgRoutePrefix}/app/admin/organization`,
        ModeratorBlackWords: (orgRoutePrefix = ':orgRoutePrefix') => `/${orgRoutePrefix}/app/admin/moderator/blackWords`,
        Trends: (orgRoutePrefix = ':orgRoutePrefix') => `/${orgRoutePrefix}/app/admin/moderator/trends`,
        Reports: (orgRoutePrefix = ':orgRoutePrefix') => `/${orgRoutePrefix}/app/admin/moderator/reports`,
        BulkSmsMulti: (orgRoutePrefix = ':orgRoutePrefix') => `/${orgRoutePrefix}/app/admin/moderator/bulkSmsMulti`,
        SystemSettings: (orgRoutePrefix = ':orgRoutePrefix') => `/${orgRoutePrefix}/app/admin/systemSettings`,
        AmbassadorRequests: (orgRoutePrefix = ':orgRoutePrefix') => `/${orgRoutePrefix}/app/admin/ambassadorRequests`,
        CustomReports: (orgRoutePrefix = ':orgRoutePrefix') => `/${orgRoutePrefix}/app/admin/custom-reports`
    },
    Application: {
        Dashboard: (orgRoutePrefix = ':orgRoutePrefix') => `/${orgRoutePrefix}/app`,
        User: {
            Settings: (orgRoutePrefix = ':orgRoutePrefix', userId = ':id') => {
                return `/${orgRoutePrefix}/app/settings/user/${userId}`;
            }
        },
        Faq: (orgRoutePrefix = ':orgRoutePrefix') => `/${orgRoutePrefix}/app/faq`,
        Businesses: {
            List: (orgRoutePrefix = ':orgRoutePrefix') => `/${orgRoutePrefix}/app/businesses`,
            Add: (orgRoutePrefix = ':orgRoutePrefix') => `/${orgRoutePrefix}/app/business/add`,
            Settings: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId") => `/${orgRoutePrefix}/app/${businessId}/settings`,
            Reports: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId") => `/${orgRoutePrefix}/app/${businessId}/business-reports`,
            Trends: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId") => `/${orgRoutePrefix}/app/${businessId}/trends`,
            Sms: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId") => `/${orgRoutePrefix}/app/${businessId}/sms`,
            Feedback: {
                List: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId") => `/${orgRoutePrefix}/app/${businessId}/feedback`,
                OptOut: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId") => `/${orgRoutePrefix}/app/${businessId}/feedback/optout`,
                Archived: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId") => `/${orgRoutePrefix}/app/${businessId}/feedback/archived`,
                Reply: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId", id = ":id") => `/${orgRoutePrefix}/app/${businessId}/feedback/${id}/reply`
            },
            DeactiveDashboard: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId") => `/${orgRoutePrefix}/app/${businessId}/deactivated`,
            Customers: {
                List: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId") => `/${orgRoutePrefix}/app/${businessId}/customers`,
                BulkSms: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId") => `/${orgRoutePrefix}/app/${businessId}/customers/sms`,
                Add: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId") => `/${orgRoutePrefix}/app/${businessId}/customers/add`,
                AddList: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId") => `/${orgRoutePrefix}/app/${businessId}/customers/addList`,
                BulkSmsDetails: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId", id = ":id") => `/${orgRoutePrefix}/app/${businessId}/bulkSms/${id}/details`,
                EditSms: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId", id = ':id') => `/${orgRoutePrefix}/app/${businessId}/customers/addList/editSms/${id}`,
                AddListCopy: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId", id = ':id') => `/${orgRoutePrefix}/app/${businessId}/customers/addList/copy/${id}`,
                Edit: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId", id = ':id') => `/${orgRoutePrefix}/app/${businessId}/customer/edit/${id}`,
                Get: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId", id = ":id", from = ":from") => `/${orgRoutePrefix}/app/${businessId}/customers/${id}/${from}`
            },
            Groups: {
                List: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId") => `/${orgRoutePrefix}/app/${businessId}/groups`,
                AddEdit: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId", id = ":id") => `/${orgRoutePrefix}/app/${businessId}/groups/${id}`
            },
            LoyaltyProgram: {
                List: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId") => `/${orgRoutePrefix}/app/${businessId}/loyalty-program`,
                Add: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId") => `/${orgRoutePrefix}/app/${businessId}/loyalty-program/add`,
                Item: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId", loyaltyProgramId = ":loyaltyProgramId") => `/${orgRoutePrefix}/app/${businessId}/loyalty-program/item/${loyaltyProgramId}`,
                Transactions: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId", loyaltyProgramId = ":loyaltyProgramId") => `/${orgRoutePrefix}/app/${businessId}/loyalty-program/item-transactions/${loyaltyProgramId}`
            },
            Surveys: {
                List: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId") => `/${orgRoutePrefix}/app/${businessId}/surveys`,
                AddEdit: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId", id = ":id") => `/${orgRoutePrefix}/app/${businessId}/surveys/${id}`,
                Publish: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId", id = ":id") => `/${orgRoutePrefix}/app/${businessId}/surveys/${id}/publish`,
                SurveySms: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId", id = ":id") => `/${orgRoutePrefix}/app/${businessId}/surveys/sms/${id}`,
                SurveyResults: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId", id = ":id") => `/${orgRoutePrefix}/app/${businessId}/survey/sms/${id}`
            },
            Users: {
                List: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId") => `/${orgRoutePrefix}/app/${businessId}/users`,
                Edit: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId", id = ":id") => `/${orgRoutePrefix}/app/${businessId}/users/${id}/edit`
            },
            SmsTemplate: {
                List: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId") => `/${orgRoutePrefix}/app/${businessId}/sms-template`,
                Add: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId", id = ":id") => `/${orgRoutePrefix}/app/${businessId}/sms-template/${id}`,
                Edit: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId", id = ":id") => `/${orgRoutePrefix}/app/${businessId}/sms-template/${id}/edit`
            },
            QrCodes: {
                List: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId") => `/${orgRoutePrefix}/app/${businessId}/qr-code`
            },
            Packages: {
                Upgrade: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId") => `/${orgRoutePrefix}/app/${businessId}/packages`
            },
            Promos: {
                List: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId") => `/${orgRoutePrefix}/app/${businessId}/promos`,
                AddEdit: (orgRoutePrefix = ':orgRoutePrefix', businessId = ':businessId', action = ':action', id = ':id') => `/${orgRoutePrefix}/app/${businessId}/promos/${action}/${id}`
            }
        },
        BlackWord: {
            List: (orgRoutePrefix = ':orgRoutePrefix', businessId = ":businessId") => `/${orgRoutePrefix}/app/${businessId}/blackWords`,
            Add: (orgRoutePrefix = ':orgRoutePrefix') => `/${orgRoutePrefix}/app/blackWord/add`,
            Edit: (orgRoutePrefix = ':orgRoutePrefix', id = ':id') => `/${orgRoutePrefix}/app/blackWord/edit/${id}`
        }
    }
};
exports.INITIAL_STATE = {
    authentication: {},
    landingPage: {
        modal: LandingStore_1.LandingModal.Closed
    },
    businesses: {
        loadingProgress: ProgressState.Loading
    },
    dialogReducer: {
        type: DialogReducer_1.DialogType.Hidden
    },
    feedbacks: {
        loadingProgress: ProgressState.Loading
    },
    template: TemplateConstants_1.TemplateInitialState
};
exports.ACTIONS = {
    Authentication: {
        LOGIN: "Authentication.LOGIN",
        LOGIN_SUCCESS: "Authentication.LOGIN_SUCCESS",
        LOGIN_FAILED: "Authentication.LOGIN_FAILED",
        TIME_ZONE: "Authentication.TIME_ZONE",
        REGISTER: "Authentication.REGISTER",
        REGISTER_ORG: "Authentication.REGISTER_ORG",
        UPDATE_ORG: "Authentication.UPDATE_ORG",
        UPDATE_ORG_BY_ACCESSTOKEN: "Authentication.UPDATE_ORG_BY_ACCESSTOKEN",
        UPDATE_ORG_SUCCESS: "Authentication.UPDATE_ORG_SUCCESS",
        REGISTER_SUCCESS: "Authentication.REGISTER_SUCCESS",
        REGISTER_FAILED: "Authentication.REGISTER_FAILED",
        LOGOUT: "Authentication.LOGOUT",
        DELETE_STATE: "Authentication.DELETE_STATE"
    },
    Coupons: {
        CLEAN_COUPONS: "Coupons.CLEAN_COUPONS",
        LOAD_COUPONS: "Coupons.LOAD_COUPONS",
        LOAD_COUPONS_SUCCESS: "Coupons.LOAD_COUPONS_SUCCESS",
        LOAD_COUPONS_FAILED: "Coupons.LOAD_COUPONS_FAILED"
    },
    Landing: {
        SHOW_MODAL: "Landing.SHOW_MODAL",
        CLOSE_MODAL: "Landing.CLOSE_MODAL"
    },
    Socials: {
        SET_ACTIVE_SOCIAL: "Socials.SET_ACTIVE_SOCIAL",
        LOAD_SOCIALS: "Socials.LOAD_SOCIALS",
        LOAD_SOCIALS_SUCCESS: "Socials.LOAD_SOCIALS_SUCCESS",
        LOAD_SOCIALS_FAILED: "Socials.LOAD_SOCIALS_FAILED"
    },
    Businesses: {
        LOAD_BUSINESSES: "Businesses.LOAD_BUSINESSES",
        UPDATE_BUSINESSES: "Businesses.UPDATE_BUSINESSES",
        LOAD_BUSINESSES_SUCCESS: "Businesses.LOAD_BUSINESSES_SUCCESS",
        LOAD_BUSINESSES_FAILED: "Businesses.LOAD_BUSINESSES_FAILED",
        SET_BUSINESS: "Businesses.SET_BUSINESS"
    },
    Features: {
        LOAD_FEATURES: "Features.LOAD_FEATURES",
        LOAD_FEATURES_SUCCESS: "Features.LOAD_FEATURES_SUCCESS",
        LOAD_FEATURES_FAILED: "Features.LOAD_FEATURES_FAILED"
    },
    Feedbacks: {
        SAVE_FEEDBACKS: "Feedbacks.SAVE_FEEDBACKS",
        SET_FILTER_DATES: "Feedbacks.SET_FILTER_DATES",
        SET_NEW_FEEDBACKS: "Feedbacks.SET_NEW_FEEDBACKS",
        SET_UNREAD_FEEDBACKS: "Feedbacks.SET_UNREAD_FEEDBACKS"
    },
    Customers: {
        SET_CHECKED_CUSTOMERS: "Customers.SET_CHECKED_CUSTOMERS",
        EXPORT_CUSTOMERS: "Customer-Export.xlsx"
    }
};
exports.DateTimeFormats = ["MM/DD/YYYY h:mm A", "YYYY-MM-DDTHH:mm:ss.sssZ"];
exports.DateRanges = {
    'Today': [moment().startOf('day'), moment().endOf('day')],
    'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
    'Last 7 Days': [moment().subtract(7, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
    'Last 30 Days': [moment().subtract(30, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
};
exports.DateRangesLabel = (startDate, endDate) => {
    let dateRange = startDate.format("M/D/YYYY") + " - " + endDate.format("M/D/YYYY");
    Object.keys(exports.DateRanges).forEach(label => {
        const range = exports.DateRanges[label];
        if (range[0].isSame(startDate) && range[1].isSame(endDate)) {
            dateRange = label;
        }
    });
    return dateRange;
};
exports.WeekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
var SurveyStatus;
(function (SurveyStatus) {
    SurveyStatus[SurveyStatus["Expired"] = "EXPIRED"] = "Expired";
    SurveyStatus[SurveyStatus["Active"] = "ACTIVE"] = "Active";
    SurveyStatus[SurveyStatus["Inactive"] = "INACTIVE"] = "Inactive";
    SurveyStatus[SurveyStatus["Pending"] = "PENDING"] = "Pending";
    SurveyStatus[SurveyStatus["InPreview"] = "IN_PREVIEW"] = "InPreview";
})(SurveyStatus = exports.SurveyStatus || (exports.SurveyStatus = {}));
exports.Messages = {
    SmsReceivers: {
        Info: "When adding a new text feedback receivers number, first, save it at the bottom of the page by clicking on the blue “Save” button, then click on the “Orange” button in the SMS receivers box to send the verification code to the receiver's phone. Enter the code in the pop-up box; click “OK” for the number to be added. "
    },
    textMessageSettlement: {
        info: "Variables are used in the Bulk Text Message body and are replaced by its' values before sending the message. Use ${VARIABLE_NAME} format in Bulk Text Message body."
    },
    phoneFieldPlaceholder: "Please click here to select the Excel file phone list from your computer.",
    phoneFieldTitle: "In your uploaded Excel file list, the phone list column must be named ”phone” for the system to recognize your Excel phone list file and be uploaded.",
    onlyPromotionTitle: "By checking box, this promotion should only be in banner promotions such as storefront windows and media ads for customers to see and engage by texting you the advertised keyword.",
    optInTitle: 'By check marking this box customers that have Opt-in to receive your text promotions by signing your contracts and/ or agreeing to your terms, will receive this promotion via this text message. If box is left Unchecked, all customers will first receive the Opt-in text message option for them to Opt-in to receive your text message promotions. Upon customers sending your assigned “Keyword Start” to be opting into your externalServices, customers then will receive a text message with your created promotion automatically.',
    couponEndDateInfo: "To reach your customers that have not been in your business for a certain time, click and select the time in the dropdown menu. The customers that have not been in your business prior to your selected time, will be receiving this message.",
    contactUsForAddLimit: "If You want to increase Your sms count please contact us.",
    autoReplyTitle: "In an event, if no one has replied to the customer’s text feedback within the time set below, your typed message in the auto-reply box will be automatically sent as a text message, replying to the customer sent text feedback.",
    autoReminderTitle: "By setting the promotion auto reminder day, customers that have not redeemed their promotion will receive a reminder text about this promotion.",
    countMessage: "This message would be send to #{COUNT} customers. \nThe number of selected customers cannot be more than 2500.",
    passwordValidation: "Password must be 6 or more characters, it should also have an uppercase and lowercase letter, number and one of these symbols….. !, @, #, $, &",
    callForwardInfo: "Leave `Forward number` field empty to reply `Default response text` to caller. If no `Default response text`, than 'This phone number does not accept calls, please send a text message.' will be replied.",
    socialMediaConfigInfo: "Please provide the links to your business' social media profile",
    templateVariableInfo: 'When choosing this option you\'ll be inserting the customer\'s name in your message.',
    multiBusinessSmsUploadMessage: 'Click to view the file requirements and layout sample',
    bulkMessageName: "Bulk Text Message",
    callForwardMessageName: "Incoming call reply",
    autoReplyAdvancedReplyTimeMessage: "Indicates how long the system should wait before sending the auto reply",
    autoReplyAdvancedReplyTypeMessage: "Indicates if the auto reply should be sent on every message or once per the given period",
    exportFilteredCustomers: "Click to export the filtered list of customers",
    exportAllCustomers: "Click to export the entire list of customers",
    surveyEmailUnavailable: "Cannot enable the Survey feature. A profile with the same email address already exists",
    ApiCredentialsInfo: "ApiCredentialsInfo",
    surveyInfo: {
        surveyName: "Please click here to add a survey name",
        expiryDate: "Please click here to choose survey's expiry date",
        description: "Please click here to add a survey description",
        openingMessage: "Please click here to add survey's opening message",
        closingMessage: "Please click here to add survey's closing message",
        questionText: "Please click here to add survey's question text",
        questionType: "Please click here to choose survey's question type",
        allowMultiSelection: "Please click here to allow multi selection for the survey's question",
        questionIsOptional: "Please click here to choose whether the question is optional or not"
    },
    qrCreation: {
        feedback: "In order to create a QR code, please click on create button.",
        promotion: "In order to create a promotion QR code, you must first create a promotion."
    },
    organization: {
        warning: "If the organization setup isn't completed, you won't be able to send SMS.",
        autoReplyConfidence: "This metric shows the percentage of positivity that the AI will acknowledge the response as positive.",
        emailFrom: "The email address from which the users will receive emails",
        superAdmin: "These emails will be treated as administrator emails and will receive notifications related to administrative actions, such as keyword activation."
    }
};
exports.uploadBulkFileBusinessStatus = {
    NOT_SENT: 'Not Started',
    NOT_STARTED: 'Not Started',
    UPLOADING: 'Uploading',
    SENDING: 'Sending',
    QUEUED: 'Queued'
};
/**
 * Bulk sms count limitation
 * @see server/constants.ts: BULKSMS_COUNT_LIMITATION
 */
exports.BULKSMS_COUNT_LIMITATION = 10000;
exports.PhoneErrorCodes = {
    "40101": {
        name: "invalid number",
        title: "not E.164 standard number",
        description: "not E.164 standard number"
    }
};
exports.TwilioErrorCodes = {
    '30003': {
        name: "unreachable",
        title: 'Unreachable destination handset',
        description: 'The destination handset you are trying to reach is switched off or otherwise unavailable.'
    },
    '30004': {
        name: 'blocked',
        title: 'Message blocked',
        description: 'The destination number you are trying to reach is blocked from receiving this message.'
    },
    '30005': {
        name: 'unknown',
        title: 'Unknown destination handset',
        description: 'Unknown destination handset. This might mean that the number you tried to message is no longer in service. We offer more insight into this error'
    },
    '30006': {
        name: 'landline',
        title: 'Landline or unreachable carrier',
        description: 'Landline or unreachable carrier. This generally means that the number you tried to message belongs to a landline. You can use this error to remove landlines from your mobile contact list, or use Twilio’s Lookup API to verify whether the number is a landline.'
    },
    "30007": {
        name: "spamOrUnwanted",
        title: "Message filtered",
        description: "Your message was identified as spam or unwanted messaging by message filtering system or was flagged as objectionable and blocked by a wireless carrier"
    },
    '21610': {
        name: 'isOptedOut',
        title: 'Opted Out',
        description: 'The message was not sent to the customer, as the customer has Opted-out to receive messages.'
    }
};
exports.smsTrends = {
    sentSms: 0,
    unsentSms: 0,
    sentSmsBulk: 0,
    unsentSmsBulk: 0,
    [exports.TwilioErrorCodes['30003'].name]: 0,
    [exports.TwilioErrorCodes['30004'].name]: 0,
    [exports.TwilioErrorCodes['30005'].name]: 0,
    [exports.TwilioErrorCodes['30006'].name]: 0,
    [exports.TwilioErrorCodes['21610'].name]: 0
};
exports.feedbackTrends = {
    customerReply: 0,
    businessReply: 0,
    neverReplied: 0,
    isOptedOut: 0,
    conversations: 0
};
exports.customerDates = {
    allCustomers: 0,
    blockedCustomers: 0,
    optOutCustomers: 0,
    activeCustomers: 0,
    newCustomers: 0,
    existingCustomer: 0
};
exports.SYSTEM_MESSAGE_VARIABLE = {
    "CUSTOMER_NAME": "[SYSTEM VARIABLE]"
};
exports.DUPLICATE_NUMBERS_GROUP_LIST = {
    DUPLICATE_NUMBER: "Duplicate number"
};
exports.CHART_COLORS = ['#09710b', '#69B34C', '#ACB334', '#FAB733', '#ff8E15', '#FF4E11', '#FF0D0D', '#A30C13', '#4267b2'];
exports.TIME_PERIODS = ['< 1m', '1m - 5m', '5m - 15m', '15m - 1h', '1h - 4h', '4h - 1d', '> 1d', 'never', 'total'];
exports.SATISFACTION_RATES = ['positive', 'negative', 'neutral'];
exports.phoneNumberSearchType = [{
    name: 'Area code',
    value: 'areaCode'
}, {
    name: 'Postal code',
    value: 'inPostalCode'
}, {
    name: 'Locality',
    value: 'inLocality'
}, {
    name: 'Region',
    value: 'inRegion'
}];
exports.reportPeriods = [{
    id: 1,
    name: "Daily",
    rule: "0 6 * * *",
    text: "You will receive a daily report every morning",
    periodIdentifire: 1
}, {
    id: 2,
    name: "Weekly",
    rule: "0 6 * * MON",
    text: "You will receive a weekly report every Monday morning",
    periodIdentifire: 2
}, {
    id: 3,
    name: "Monthly",
    rule: "0 6 1 * *",
    text: "You will receive a monthly report every first day of the month",
    periodIdentifire: 3
}, {
    id: 4,
    name: "Quarterly",
    rule: "0 6 1 */3 *",
    text: "You will receive a quarterly report, every first day of the next quarter",
    periodIdentifire: 4
}, {
    id: 5,
    name: "Annually",
    rule: "0 6 1 1 *",
    text: "You will receive an annual report, on January 1",
    periodIdentifire: 5
}];
exports.SENTIMENT_TYPES = {
    positive: 100,
    negative: 101,
    neutral: 102
};
exports.SENTIMENT_TYPES_LOOKUP = {
    102: {
        label: 'Positive',
        key: 'positive'
    },
    101: {
        label: 'Negative',
        key: 'negative'
    },
    100: {
        label: 'Neutral',
        key: 'neutral'
    }
};
exports.SentimentTypesLabels = sentiments => {
    return sentiments.map(sentiment => exports.SENTIMENT_TYPES_LOOKUP[sentiment].label).join(', ');
};
exports.AUTO_REPLY_SCHEDULE_TYPE_OPTIONS = [{
    value: Business_1.AutoReplyScheduleTypeEnum.Weekly,
    name: 'Every Week'
}, {
    value: Business_1.AutoReplyScheduleTypeEnum.Daily,
    name: 'Every Day'
}, {
    value: Business_1.AutoReplyScheduleTypeEnum.Monthly,
    name: 'Every Month'
}, {
    value: Business_1.AutoReplyScheduleTypeEnum.Custom,
    name: 'In Custom Range'
}];
exports.AUTO_REPLY_TIME_OPTIONS = [0, 1, 5, 10, 15, 20, 30, 45, 60];
exports.WinstonLevelOptions = [{ name: "Error", value: 'error' }, { name: "Warn", value: 'warn' }, { name: "Info", value: 'info' }, { name: "HTTP", value: 'http' }, { name: "Verbose", value: 'verbose' }, { name: "Debug", value: 'debug' }, { name: "Silly", value: 'silly' }];
var LocaleEnum;
(function (LocaleEnum) {
    LocaleEnum[LocaleEnum["AUSTRALIA"] = 'en-AU'] = "AUSTRALIA";
    LocaleEnum[LocaleEnum["US"] = 'en-US'] = "US";
})(LocaleEnum = exports.LocaleEnum || (exports.LocaleEnum = {}));
exports.timezoneToLocaleMap = {
    "Australia/Sydney": LocaleEnum.AUSTRALIA
};
var PhoneNumberLengthEnum;
(function (PhoneNumberLengthEnum) {
    PhoneNumberLengthEnum[PhoneNumberLengthEnum["US_WITH_COUNTRY_CODE"] = 11] = "US_WITH_COUNTRY_CODE";
    PhoneNumberLengthEnum[PhoneNumberLengthEnum["US_WITHOUT_COUNTRY_CODE"] = 10] = "US_WITHOUT_COUNTRY_CODE";
})(PhoneNumberLengthEnum = exports.PhoneNumberLengthEnum || (exports.PhoneNumberLengthEnum = {}));
var PhoneCountryCode;
(function (PhoneCountryCode) {
    PhoneCountryCode[PhoneCountryCode["US"] = '+1'] = "US";
})(PhoneCountryCode = exports.PhoneCountryCode || (exports.PhoneCountryCode = {}));
var QrCodeTypeEnum;
(function (QrCodeTypeEnum) {
    QrCodeTypeEnum[QrCodeTypeEnum["Feedback"] = 'FEEDBACK'] = "Feedback";
    QrCodeTypeEnum[QrCodeTypeEnum["Promotion"] = 'PROMOTION'] = "Promotion";
})(QrCodeTypeEnum = exports.QrCodeTypeEnum || (exports.QrCodeTypeEnum = {}));
exports.keywordLengths = {
    min: 3,
    max: 20
};
exports.loyaltyProgramTypes = [{
    name: 'Visit'
}, {
    name: 'Subscription'
}];
exports.exportFileNames = {
    bulkSmsDownloadStats: id => {
        return `Bulk-Sms-Export-Statistics_${id}.xlsx`;
    },
    bulkSmsDownloadReasons: id => {
        return `Bulk-Sms-Export-Reasons_${id}.xlsx`;
    }
};


//////////////////
// WEBPACK FOOTER
// ./client/src/constants.ts
// module id = 335
// module chunks = 0 1 2